import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

// COMPONENTI
import { Helmet } from "react-helmet";
import SubHeaderDefault from "../Header/subHeader/SubHeaderDefault";

//HOOKs
import useInViewAnimation from "../../hooks/utilityStyle/useInViewAnimation";

const InternalArchitect: React.FC = () => {

    const { t } = useTranslation();

    const [pageReady, setPageReady] = useState(false);
    useEffect(() => {
        // Questo set time out è divuto al video che falsa lo posizione degli elemnti nel DOM finche non carica
        const timer = setTimeout(() => { 
            setPageReady(true);
        }, 1000);

        return () => clearTimeout(timer);
    }, []);

    const ref1 = useRef<HTMLHeadingElement>(null);
    const allRefs: React.RefObject<HTMLHeadingElement | HTMLParagraphElement | null>[] = [ref1];
    useInViewAnimation({animationElementsRef: allRefs, animationClass: 'fade-in', pageReady: pageReady});

    return (
        <>
            <Helmet>
                    <title>{t("architectPage.pageTitle")}</title>
                    <meta name="description" content={t("architectPage.metaDescription") as string} />
            </Helmet>

            <SubHeaderDefault title={t("architectPage.subHeaderTitle") as string} isSeo={true} />

            <main id="internal-architect-page" className="space-ptb bg-custom">
                <div className="container-fluid w-special">
                    <h2 className="mb-4">{t("architectPage.title")}</h2>
                    <p dangerouslySetInnerHTML={{ __html: t("architectPage.para1") as string }}></p>
                    <p dangerouslySetInnerHTML={{ __html: t("architectPage.para2") as string }}></p>
                    <p dangerouslySetInnerHTML={{ __html: t("architectPage.para3") as string }}></p>
                    <p dangerouslySetInnerHTML={{ __html: t("architectPage.para4") as string }}></p>
                    <p dangerouslySetInnerHTML={{ __html: t("architectPage.para5") as string }}></p>
                    <p dangerouslySetInnerHTML={{ __html: t("architectPage.para6") as string }}></p>
                    <div className="row">
                        <div className="col-12 mt-4" ref={ref1}>
                            <img src="/assets/images/team/team.jpg" alt="Salvadori Team" className="img-fluid"/>
                        </div>
                    </div>
                </div>
            </main>
        </>
    );
};

export default InternalArchitect;